const currentEnv = process.env.REACT_APP_ENVIRONMENT || "default";

/* --- Environments -------------------------------------------------------- */

const ENV_SCOPE = {
  COOKIE: "cookie",
  SERVICE: "service",
  TRACKING: "tracking",
};

const envType = {
  [ENV_SCOPE.COOKIE]: {
    development: "development",
    staging: "staging",
    production: "helearning",
    local: "local",
    default: "local",
  },
  [ENV_SCOPE.SERVICE]: {
    development: "development",
    staging: "staging",
    production: "production",
    local: "local",
    test: "test",
    default: "local",
  },
  [ENV_SCOPE.TRACKING]: {
    development: "local",
    staging: "acceptance",
    production: "production",
    local: "local",
    test: "local",
    default: "local",
  },
};

export const basePath = "/";

// @ts-ignore
const getENV = (scope: string) => envType[scope][currentEnv] || envType[scope].default;

export const cookieENV = (): string => getENV(ENV_SCOPE.COOKIE);
export const serviceENV = (): string => getENV(ENV_SCOPE.SERVICE);

type AnalyticsEnvTypes = "local" | "acceptance" | "development" | "production";
export const trackingENV = (): AnalyticsEnvTypes => getENV(ENV_SCOPE.TRACKING);

/* --- Environment checkers ------------------------------------------------ */

export const isDev = (): boolean => serviceENV() === envType[ENV_SCOPE.SERVICE].development;
export const isStaging = (): boolean => serviceENV() === envType[ENV_SCOPE.SERVICE].staging;
export const isProd = (): boolean => serviceENV() === envType[ENV_SCOPE.SERVICE].production;
export const isLocal = (): boolean => serviceENV() === envType[ENV_SCOPE.SERVICE].local;

export const isTest = (): boolean =>
  // @ts-ignore: we have to ignore this https://github.com/cypress-io/cypress/issues/3924#issuecomment-481430796
  window.Cypress || serviceENV() === envType[ENV_SCOPE.SERVICE].test;

/* --- Cookies ------------------------------------------------------------- */

export const COOKIE_ROLE = "role";
export const COOKIE_SESSION_ID = "session_id";
export const COOKIE_SESSION_TOKEN = "session_token";
export const COOKIE_REFRESH_TOKEN = "refresh_token";
export const COOKIE_PREFIX = "__Host-";
export interface CookieOptionsInterface {
  domain?: string;
  secure?: boolean;
  expires?: number;
  sameSite?: "None" | "Lax";
}

export const getCookieOptions = (): CookieOptionsInterface => {
  if (["development", "staging", "production"].includes(currentEnv)) {
    return {
      secure: true,
      expires: 7,
      sameSite: "Lax",
    };
  }

  return {};
};

/* --- Misc. constants ----------------------------------------------------- */

export const NOT_VALID_VALUES = [null, undefined, "", []];
